import React from 'react';
import attract from './../../images/attract.svg'
import engage from './../../images/engage.svg'
import quality from './../../images/quality.svg'
import retain from './../../images/retain.svg'
import './styles.css'

export default function Hire() {
  return (
    <section className="landing__hire">
      <h2 className="landing__hire__heading">AB Hires Advantage</h2>
      <ul className="advantage__list">
        <li className="advantage__listitem">
          <div>
            <img src={attract} alt=""/>
          </div>
          <p>attract</p>

        </li>
        <li className="advantage__listitem">
          <div>
            <img src={engage} alt=""/>
          </div>
          <p>engage</p>
        </li>
        <li className="advantage__listitem">
          <div>
            <img src={quality} alt=""/>
          </div>
          <p>quality</p>
        </li>
        <li className="advantage__listitem">
          <div>
            <img src={retain} alt=""/>
          </div>
          <p>retain</p>
        </li>
      </ul>
    </section>
  );
}
